import React from "react";
import { Typography } from "@material-ui/core";

//
import { Link } from "react-router-dom";
//
import useStyles from "./stylesIfCartIsEmpty";

//
//
//So if the cart is EMPTY show the following:
const RenderEmptyCart = () => {
  //
  const classes = useStyles();

  return (
    <div className={classes.deletedCartPage}>
      <Typography variant="subtitle1" className={classes.titleDeletedCart}>
        Shopping bag is empty
      </Typography>
      {/*  */}
      <Typography variant="subtitle1" className={classes.titleDeletedCart}>
        <Link to="/" className={classes.link}>
          start adding some
        </Link>
      </Typography>
    </div>
  );
};
export default RenderEmptyCart;
